
    <div
      [ngClass]="{
        'border-danger': formControl.errors && formControl.touched,
        disabled: field.templateOptions.disabled
      }"
      style="border: 1px solid transparent;
    padding: 0 0.1rem 0 0;"
    >
      <app-editor
        [elementId]="field.id"
        [dataForm]="formControl.value"
        [disabled]="field.templateOptions.disabled"
        (notify)="
          formControl.patchValue($event.id); formControl.markAsTouched()
        "
      ></app-editor>
      <!-- {{ field.templateOptions | json }} -->
    </div>
  